/* This file is autogenerated, see readme.md for instructions */
import ArrowDownSvgIcon from '@bloomreach/banana-theme/icons/arrow-down.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ArrowDownIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ArrowDownSvgIcon />
    </Icon>
  );
});

ArrowDownIcon.displayName = 'ArrowDownIcon';

export default ArrowDownIcon;
